import React from 'react';

const TabNavItem = ({ id, title, icon, iconfill, activeTab, setActiveTab }) => {
    const isActive = activeTab === id;

    return (
        <li className="clinic-detail-nav__item">
            <button
                type="button"
                className={`clinic-detail-nav__link ${isActive ? 'clinic-detail-nav__link--active' : ''}`}
                onClick={() => setActiveTab(id)}
                aria-current={isActive ? 'page' : undefined}
            >
                <i className={isActive && iconfill ? iconfill : icon}></i>
                <span>{title}</span>
            </button>
        </li>
    );
};

export default TabNavItem;
